import { render, staticRenderFns } from "./SysConfigModal.vue?vue&type=template&id=66a4ad68&"
import script from "./SysConfigModal.vue?vue&type=script&lang=js&"
export * from "./SysConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports